import { computed } from 'vue';

import { UseChatMessageBubbleCommonOptions } from '@/types/composables';
import { MessageText } from '@/types/socket';

export function useMessageBubbleCommon({
  chatMessage,
  isHidden,
  setEmptyBubble,
}: UseChatMessageBubbleCommonOptions) {
  // 통역중 여부
  const isListening = computed((): boolean => {
    const { src, tgt } = chatMessage.value;
    const isEmptySrc =
      !Array.isArray(src.contents) || src.contents.length === 0;
    const isEmptyTgt =
      !Array.isArray(tgt.contents) || tgt.contents.length === 0;
    const isEmptyBubble = isEmptySrc && isEmptyTgt;
    return isEmptyBubble;
  });

  // 통역본 존재 여부
  const isEmptyTgt = computed((): boolean => {
    return getIsEmptyContents(chatMessage.value.tgt.contents);
  });

  // 원본 존재 여부
  const isEmptySrc = computed((): boolean => {
    return getIsEmptyContents(chatMessage.value.src.contents);
  });

  const handleChangeReset = (resetNew: '0' | '1') => {
    const { callLogId, src, tgt } = chatMessage.value;
    const isReset = resetNew === '1';
    function isEmpty(contents?: MessageText[]) {
      if (!Array.isArray(contents) || contents.length === 0) {
        return true;
      }
      return contents.every((item) => item.content?.trim() === '');
    }
    const isEmptyBubble = isEmpty(src?.contents) && isEmpty(tgt?.contents);
    if (isReset && isEmptyBubble) {
      isHidden.value = true;
      setEmptyBubble(callLogId);
    } else {
      isHidden.value = false;
      setEmptyBubble('');
    }
  };

  // contents 비었는지
  const getIsEmptyContents = (contents: Array<MessageText>) => {
    if (!Array.isArray(contents) || contents.length === 0) return true;

    return contents.every(({ content }) =>
      [undefined, null, ''].includes(content?.trim())
    );
  };

  return {
    isListening,
    isEmptyTgt,
    isEmptySrc,
    handleChangeReset,
  };
}
